// Match the API's America/New_York calendar dates, regardless of browser timezone.
export function orderDays(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const part = type => parts.find(item => item.type === type).value;
  const today = new Date(`${part('year')}-${part('month')}-${part('day')}T00:00:00Z`);
  return Array.from({ length: 30 }, (_, index) => {
    const day = new Date(today);
    day.setUTCDate(day.getUTCDate() - 29 + index);
    return { date: day.toISOString().slice(0, 10), count: 0 };
  });
}

export function summarizeOrders(collection, days) {
  const counts = new Map(days.map(day => [day.date, 0]));
  const seen = new Set();
  for (const order of collection) {
    if (!order.raw?.id || !order.raw?.created_last) throw new Error('Order data is incomplete.');
    if (seen.has(order.raw.id)) continue;
    seen.add(order.raw.id);
    const date = order.raw.created_last.slice(0, 10);
    if (counts.has(date)) counts.set(date, counts.get(date) + 1);
  }
  return days.map(day => ({ ...day, count: counts.get(day.date) }));
}
